import { useColorMode } from "../../components/ui/color-mode";
import palette from "./palette";

const usePalette = () => {
    const { colorMode } = useColorMode();
    const mode = colorMode === "light" ? "light" : "dark";

    return {
        header: palette.colors.header[mode],
        accent: palette.colors.accent[mode],
        background: palette.colors.background[mode],
        backgroundHover: palette.colors.backgroundHover[mode],
        text: palette.colors.text[mode],
        accentText: palette.colors.accentText[mode],
        colorScheme: palette.colors.colorScheme[mode],
    }
}

export default usePalette;